import React, { useState, useEffect, Fragment } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import { Typography, Box } from '@material-ui/core';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

import SectionTitle from 'on_web/components/shared/Common/SectionTitle';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import Progress from 'on_web/components/shared/Common/Progress/Progress';
import { makeStyles } from '@material-ui/core/styles';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  icon: {
    fontSize: '80px',
  },
});

export default function DnaProcessing(props) {
  const context = React.useContext(UserProfileContext);
  const [uploadedFileName] = useState(
    context && context.fileName ? context.fileName : ''
  );
  const classes = useStyles();

  const onClickNext = () => {
    if (props.onClickNext) {
      props.onClickNext();
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();
  return (
    <div>
      <Header />
      {props.forPce && <PceStepProgressIndicator selectedSlideIx={0} />}

      <SectionTitle
        text={t('onboarding.dnaSection.dnaProcessing.sectionTitle')}
      />

      <Box
        p={{ xs: 2.5, sm: 3, md: 4 }}
        mr={{ xs: 2.5 }}
        justifyContent="center"
        display="flex"
      >
        {props.progress === 100 ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            {props.uploadSuccessful ? (
              <Fragment>
                <CheckCircleIcon color="primary" className={classes.icon} />
                <Typography
                  variant="h2"
                  color="primary"
                  style={{
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    wordBreak: 'break-word',
                  }}
                >
                  {t('onboarding.dnaSection.dnaProcessing.fileUploadSuccess', {
                    file_name: uploadedFileName,
                  })}
                </Typography>
                <Box mt={3} ml={1}>
                  <Typography
                    variant="body1"
                    align="center"
                    style={{ fontSize: '14px' }}
                  >
                    {t('onboarding.dnaSection.dnaUploadFile.fileUploaded')}
                  </Typography>
                </Box>
              </Fragment>
            ) : props.uploadSuccessful === false ? (
              <Fragment>
                <ErrorIcon color="error" className={classes.icon} />
                <Typography variant="h2" color="error">
                  {t('onboarding.dnaSection.dnaProcessing.fileUploadError', {
                    file_name: uploadedFileName,
                  })}
                </Typography>
              </Fragment>
            ) : (
              <Fragment></Fragment>
            )}
          </Box>
        ) : (
          <Progress caption="Upload" value={props.progress} />
        )}
      </Box>

      <StickyNavigation
        nextButtonDisabled={props.progress !== 100}
        hideBack={props.uploadSuccessful}
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
      />
    </div>
  );
}
